import type { Rate } from '@/api/catalog';
import type { Schemas } from '@/api/client';
import dayjs from '@/lib/dayjs';

export type Kind = Schemas['SetRateRequest']['kind'];
export type Level = Schemas['SetRateRequest']['level'];

/** Aktuell gültiger Satz einer Ebene (ohne Vererbung). */
export function currentRate(rates: Rate[], kind: Kind, level: Level, refId?: string, ref2Id?: string): Rate | undefined {
  const today = dayjs().format('YYYY-MM-DD');
  return rates
    .filter((r) => r.kind === kind && r.level === level && (r.refId ?? undefined) === refId && (r.ref2Id ?? undefined) === ref2Id)
    .filter((r) => !r.validFrom || r.validFrom <= today)
    .sort((a, b) => (b.validFrom ?? '').localeCompare(a.validFrom ?? ''))[0];
}
